import { AppState } from '../../rootReducer';

export const getCategoriesLoading = (state: AppState) =>
  state.categories.loading;
export const getCategories = (state: AppState) => state.categories.data;
export const getCatSelected = (state: AppState) => state.categories.selected;
export const getCategoriesError = (state: AppState) => state.categories.error;
